import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getSeniorSurveyDetails = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/senior-survey/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createSeniorSurvey = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/senior-survey/`,
      method: RequestMethod.POST,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateSeniorSurvey = ({ params, data, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/senior-survey/`,
      method: RequestMethod.PATCH,
      data,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const completeSeniorSurvey = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/senior-survey/complete/`,
      method: RequestMethod.POST,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSeniorSurveyCount = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/senior-survey/count/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const exportSeniorSurveyContacts = ({ payload, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/senior-survey/contacts/export/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSeniorSurveyGoals = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/senior-survey/goals/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const exportPostSecondaryGoalsReport = ({
  params,
  payload,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/senior-survey/goals/export/`,
      method: RequestMethod.POST,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSeniorSurveyStudentGoals = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/senior-survey/goals/students/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getMilitaryBranchCounts = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/senior-survey/goals/students/military-branch-count/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const exportAllCSVReports = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/senior-survey/complete/export/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);
